import telegramIcon from '../images/icons/telegram.png';
import whatsappIcon from '../images/icons/whatsapp.png';
import viberIcon from '../images/icons/viber.png';
import phoneIcon from '../images/icons/phone-call.png';
import ContactRequestForm from "@/components/ContactRequestForm.jsx";
export default function () {
  return (
    <div>
      <div>
        <h2 className="text-2xl font-medium text-gray-900">Не нашли что искали?</h2>

        <p className="mt-4 max-w-lg text-gray-500">
          Напишите нам в вашем любимом мессенджере, позвоните нам или оставьте сообщение через форму на сайте и мы сами
          перезвоним Вам!
        </p>

        <p className="mt-4 max-w-lg text-gray-500">
          У нас самый большой ассортимент в Красноярске. Огромный опыт в аэродизайне.
        </p>
      </div>
      <div className="flex space-x-4 items-center py-8">
        <div className="flex space-x-4 items-center py-8">
          <div>
            <a href="https://wa.me/79029274257" target="_blank" rel="noreferrer">
              <img src={whatsappIcon} className="size-10"/>
            </a>
          </div>
          <div>
            <a href="https://t.me/shararam24" target="_blank" rel="noreferrer">
              <img src={telegramIcon} className="size-10"/>
            </a>
          </div>
          <div>
            <a href="tel:+79029274257" target="_blank" rel="noreferrer">
              <img src={phoneIcon} className="size-10"/>
            </a>
          </div>
        </div>
      </div>

      <ContactRequestForm/>
    </div>
  )
}